import { TopicActionsSection } from '@communities/content-management/components';
import { EntityType, WorkflowType } from '@communities/content-management/domain';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { ModerationLabelSection } from '@moderation/components/ModerationLabelSection';
import { Section } from '@soteria/design-system-ve';

import { ActionsTab } from './ActionsTab';
import * as styles from './ClassificationTab.css';
import { PoliciesTab } from './PoliciesTab';
import { TopicsTab } from './TopicsTab';

interface ModerationTabProps {
  communityId: string;
  isEntityAdmin: boolean;
}

/**
 * Moderation tab component for community management
 * Provides access to moderation tools including traits management, topics, actions, and policies
 */
function ModerationTabComponent({ communityId, isEntityAdmin }: ModerationTabProps) {
  return (
    <div className={styles.tabContainer}>
      {/* Moderation Topics Settings Section */}
      <TopicsTab
        showModerationSettings
        entityId={communityId}
        entityType={EntityType.COMMUNITY}
        isEntityAdmin={isEntityAdmin}
        sectionTitle="Moderation Topics Settings"
      />

      {/* Moderation Labels Section */}
      <Section spacing="large">
        <ModerationLabelSection communityId={communityId} />
      </Section>

      {/* Moderation Policies Section */}
      <PoliciesTab communityId={communityId} isEntityAdmin={isEntityAdmin} sectionTitle="Moderation Policies" workflowType={WorkflowType.MODERATION} />

      {/* Moderation Actions Section */}
      <ActionsTab
        entityId={communityId}
        entityType={EntityType.COMMUNITY}
        isEntityAdmin={isEntityAdmin}
        sectionTitle="Moderation Actions"
        workflowType={WorkflowType.MODERATION}
      />

      {/* Moderation Workflow - Topic Actions */}
      <Section spacing="medium">
        <TopicActionsSection entityId={communityId} entityType={EntityType.COMMUNITY} isEntityAdmin={isEntityAdmin} workflowType={WorkflowType.MODERATION} />
      </Section>
    </div>
  );
}

export const ModerationTab = withAppInsightsTracking(ModerationTabComponent, 'ModerationTab');
